import { Popover } from "@patternfly/react-core";
import { OutlinedQuestionCircleIcon } from "@patternfly/react-icons";
import { type FC, useState } from "react";

export const ValidatedProjectTypePopup: FC<{
	text: string;
}> = ({ text }) => {
	const [isVisible, setIsVisible] = useState(false);
	return (
		<>
			<span id="popover-span" />
			<Popover
				minWidth={"20em"}
				appendTo={() => document.getElementById("popover-span") ?? document.body}
				aria-label={text}
				isVisible={isVisible}
				shouldOpen={() => setIsVisible(true)}
				shouldClose={() => setIsVisible(false)}
				headerContent={<div>This project is not certified</div>}
				bodyContent={
					<div>
						This project has only been validated, which means it can be published but will not be marked as certified in
						the Red Hat Ecosystem Catalog. To certify it, complete the project's certification checklist.
					</div>
				}
			>
				<div
					id={"popover-trigger"}
					onClick={() => {
						setIsVisible(true);
					}}
				>
					<span
						style={{
							cursor: "pointer",
						}}
					>
						{text}&nbsp;
					</span>
					<OutlinedQuestionCircleIcon
						style={{
							marginLeft: "var(--pf-global--spacer--xs)",
						}}
					/>
				</div>
			</Popover>
		</>
	);
};
